<template>
    <div class="menu-action" :class="status ? 'active' : ''" @mouseleave="status = false">
        <button type="button" @click="toggle">
            <i class="fal fa-ellipsis-v"></i>
        </button>
        <div class="options">
            <ul>
                <slot />
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            text: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                status: false
            }
        },
        methods: {
           toggle(){
               this.status = !this.status
           }
        },
        created(){
		}
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';

</style>
